import {useHubQuery} from '../../QueryProvider'

export const useGetDismissedOrderCancellationBanners = (enabled = true) => {
  return useHubQuery('dismissedOrderCancellationBanners', [], {
    enabled,
    refetchOnWindowFocus: false,
    staleTime: 5 * 60 * 1000
  })
}
